import { ExpertDialog } from './ExpertDialog';
import { IExpert } from '@/shared/IExpert';

export const NewExpertDialog = (props: {
  onClose: (open: boolean) => void;
  onAddNewExpert: (expert: IExpert, invite: boolean) => Promise<void>;
}) => {

  const defaultExpert: IExpert = {
    id: '',
    name: '',
    email: '',
    role: 'reviewer'
  };

  return (
    <ExpertDialog
      expert={defaultExpert}
      onClose={() => props.onClose(false)}
      onSave={props.onAddNewExpert}
      saveLabel='Add'
      savingLabel='Adding...'
      title='Add New Expert'
      description='This will register a new platform user (reviewer or staff). An invitation will be sent to the external reviewer to grant the access to the platform.'
    />
  )
}